import dayjs from 'dayjs';

/**
 * A Delphi bridge sender that stops reports nothing, so the backend reads its
 * silence instead (`GET /api/legacy-bridge-activity/senders`). CASA2's sender
 * kept 61 operations for two days on 2026-10-24 with nobody aware (bridge day
 * check 2026-10-26, G-10). This turns one warning into its line of text.
 */

interface SenderWarningBase {
    cashPointId: number;
    cashPointName: string | null;
    lastEventAt: string;
}

/** As `GET /api/legacy-bridge-activity/senders` returns it. */
export type BridgeSenderWarning =
    | (SenderWarningBase & { kind: 'backlog'; pendingCount: number; reportedAt: string })
    | (SenderWarningBase & { kind: 'silent' });

export interface BridgeSenderHealthResponse {
    enabled: boolean;
    serverTime: string;
    warnings: BridgeSenderWarning[];
}

export interface BridgeSenderWarningText {
    key: 'controlRoom.bridgeSender.silent' | 'controlRoom.bridgeSender.backlog';
    values: Record<string, string | number>;
}

const formatTime = (value: string): string => dayjs(value).format('YYYY-MM-DD HH:mm');

export const bridgeSenderWarningText = (warning: BridgeSenderWarning): BridgeSenderWarningText => {
    const values = {
        cashPoint: warning.cashPointName ?? `#${warning.cashPointId}`,
        lastEventAt: formatTime(warning.lastEventAt),
    };
    if (warning.kind === 'backlog') {
        return {
            key: 'controlRoom.bridgeSender.backlog',
            values: {
                ...values,
                pendingCount: warning.pendingCount,
                reportedAt: formatTime(warning.reportedAt),
            },
        };
    }
    return { key: 'controlRoom.bridgeSender.silent', values };
};
